(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    // Shared, ref-counted scroll lock so multiple overlays (menu drawer, cart drawer) can't
  // clobber each other's body-overflow reset — closing one no longer unlocks the page while
  // another is still open.
  if (!window.MetryScrollLock) {
    window.MetryScrollLock = (function () {
      var count = 0;
      return {
        lock: function () { count++; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; },
        unlock: function () { count = Math.max(0, count - 1); if (count === 0) { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; } }
      };
    })();
  }

  (function () {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('reveal-in');
      });
    }

    function initReveal() {
      var els = document.querySelectorAll('[data-reveal]');
      if (reduce || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initImageFade() {
      document.querySelectorAll('img.lazy-fade').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      });
    }

    function start() { initReveal(); initImageFade(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atom-carousel')) {
    customElements.define(
      'atom-carousel',
      class AtomCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          if (!this.track) return;

          this.slides = Array.from(this.track.children);
          if (!this.slides.length) return;

          this.prevBtn = this.querySelector('[data-carousel-prev]');
          this.nextBtn = this.querySelector('[data-carousel-next]');
          this.dotsWrap = this.querySelector('[data-carousel-dots]');

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));

          // Position is the single source of truth — no separately tracked index to
          // drift out of sync with what is actually on screen.
          this.track.addEventListener('scroll', () => this.queueSync(), { passive: true });

          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); this.page(1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.page(-1); }
          });

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => this.rebuild());
            this.ro.observe(this.track);
          }

          this.rebuild();
        }

        /** Real snap step = card width + gap, measured from two adjacent slides.
            Using clientWidth as the step overcounted pages on narrow viewports and
            left a dead dot that never lit up. */
        get step() {
          if (this.slides.length < 2) return this.track.clientWidth || 1;
          const d = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
          return d > 0 ? d : (this.track.clientWidth || 1);
        }

        get perView() {
          return Math.max(1, Math.round(this.track.clientWidth / this.step));
        }

        get pageCount() {
          if (this.track.scrollWidth - this.track.clientWidth <= 1) return 1;
          return Math.max(1, Math.ceil(this.slides.length / this.perView));
        }

        rebuild() {
          // A carousel inside a hidden tab panel measures 0 wide. Measuring it would
          // yield a bogus page count and permanently hide the dots — ResizeObserver
          // fires again the moment the panel is shown, so just skip.
          if (!this.track.clientWidth) return;

          const pages = this.pageCount;
          if (this.dotsWrap) {
            // Set unconditionally: previously the restore path sat behind a
            // "dot count changed" test, so a re-shown panel never got hidden cleared.
            this.dotsWrap.hidden = pages < 2;
            if (pages >= 2 && this.dotsWrap.childElementCount !== pages) {
              this.dotsWrap.textContent = '';
              const frag = document.createDocumentFragment();
              for (let i = 0; i < pages; i++) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'carousel__dot';
                dot.setAttribute('role', 'tab');
                dot.setAttribute('aria-label', String(i + 1));
                dot.addEventListener('click', () => this.goToPage(i));
                frag.appendChild(dot);
              }
              this.dotsWrap.appendChild(frag);
            }
          }
          this.syncUI();
        }

        queueSync() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this.syncUI();
          });
        }

        syncUI() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          // 1px tolerance: fractional layout widths mean scrollLeft rarely lands exactly.
          const atStart = t.scrollLeft <= 1;
          const atEnd = t.scrollLeft >= max - 1;

          if (this.prevBtn) this.prevBtn.disabled = atStart;
          if (this.nextBtn) this.nextBtn.disabled = atEnd;

          if (this.dotsWrap && !this.dotsWrap.hidden) {
            const dots = this.dotsWrap.children;
            const span = this.perView * this.step;
            const current = span > 0
              ? Math.min(dots.length - 1, Math.round(t.scrollLeft / span))
              : 0;
            for (let i = 0; i < dots.length; i++) {
              dots[i].setAttribute('aria-selected', i === current ? 'true' : 'false');
            }
          }
        }

        behavior() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        }

        page(dir) {
          this.track.scrollBy({ left: dir * this.perView * this.step, behavior: this.behavior() });
        }

        goToPage(i) {
          this.track.scrollTo({ left: i * this.perView * this.step, behavior: this.behavior() });
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          if (this._raf) cancelAnimationFrame(this._raf);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-code')) {
    customElements.define('gift-code', class extends HTMLElement {
      connectedCallback() {
        const b = this.querySelector('[data-code]');
        if (b) b.addEventListener('click', () => {
          if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.code);
          b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
